module.exports = __webpack_public_path__ + "media/images/game/bonus_tasks/prezentace-ac2d945c4b259a736739cf36023a8b09.png";